import { render, staticRenderFns } from "./AvitoCityForm.vue?vue&type=template&id=eb0f35dc&"
import script from "./AvitoCityForm.vue?vue&type=script&lang=js&"
export * from "./AvitoCityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports